<template>
    <NavigationBar />
    <section id="section-Home">
        <el-row class="odd-row">
            <el-col :span="24">
                <div class="common-layout">
                    <el-container>
                        <div class="avatar-layout"><img src="images/avatar.jpg" class="avatar-content"></div>
                        <el-main>
                            <div class="head">Pedestrian1</div>
                            <el-container class="education-container">
                                <div class="education-block">
                                    <el-container>
                                        <el-header class="education-title-layout">
                                            <div class="education-title">Education</div>
                                        </el-header>
                                        <el-container style="margin-left:3.25vw">
                                            <div class="education-icon">
                                                <el-icon>
                                                    <img src="images/hdu.webp" class="school-badge-content">
                                                </el-icon>
                                            </div>
                                            <el-container>
                                                <div class="graduation-content">
                                                    <div class="text-row school">Hangzhou Dianzi University</div>
                                                    <div class="text-row education-content">
                                                        Bachelor of Engineering, Computer Science and Technology
                                                    </div>
                                                    <div class="text-row time">2020.9-2024.6</div>
                                                </div>
                                            </el-container>
                                        </el-container>
                                    </el-container>
                                </div>
                            </el-container>
                        </el-main>
                    </el-container>
                </div>
            </el-col>
        </el-row>
    </section>
    <section id="section-Work">
        <el-row class="even-row">
            <el-col :span="24">
                <div class="common-layout">
                    <el-container>
                        <el-aside class="title-block">
                            <div class="title-content">Work Experience</div>
                        </el-aside>
                        <el-main style="margin-left:20%">
                            <el-container>
                                <VueCard :title="'Infrastructure Developer'" company='Tencent WXG' time='2024.7 - Present'
                                    :contents="[{ content: 'Unknown' }]" image_path='images/Tencent_EN.svg'
                                    :image_style="TencentImageStyle" />
                            </el-container>
                        </el-main>
                    </el-container>
                </div>
            </el-col>
        </el-row>
    </section>
    <section id="section-Internship">
        <el-row class="odd-row">
            <el-col :span="24">
                <div class="common-layout">
                    <el-container>
                        <el-aside class="title-block">
                            <div class="title-content">Internship Experience</div>
                        </el-aside>
                        <el-main style="margin-left:20%">
                            <div>
                                <VueCard :title="'Infrastructure Developer'" company='Tencent WXG' time='2024.1 - 2024.3'
                                    :contents="[{ content: 'Storage, Leveldb, Libco' }]" image_path='images/Tencent_EN.svg'
                                    :image_style=TencentImageStyle />
                            </div>
                            <div>
                                <VueCard :title="'Software Developer'" company='Huawei' time='2023.7 - 2023.10'
                                    :contents="[{ content: 'Improve HDC tools' }]" image_path='images/Huawei.svg'
                                    :image_style="{ width: '12vw' }" />
                            </div>
                            <div>
                                <VueCard :title="'Backend Developer'" company='DolphinDB' time='2023.5 - 2023.7'
                                    :contents="[{ content: 'QuantLib plugin' }]" image_path='images/DolphinDB.svg'
                                    :image_style="DolphinDBImageStyle" />
                            </div>
                        </el-main>
                    </el-container>
                </div>
            </el-col>
        </el-row>
    </section>
    <section id="section-Competition">
        <el-row class="even-row">
            <el-col :span="24">
                <div class="common-layout">
                    <el-container>
                        <el-aside class="title-block">
                            <div class="title-content">Competition</div>
                        </el-aside>
                        <el-main style="margin-left:12%">
                            <div>
                                <VueCompetitionCard
                                    :title="'Silver Medal, The 46th ACM-ICPC Asia Shanghai Regional Programming Contest'"
                                    time='2021.11.27' image_path='images/icpc.svg' :image_style="{ width: '6vw' }" />
                            </div>
                            <div>
                                <VueCompetitionCard
                                    :title="'Silver Medal, The 47th ACM-ICPC Asia Jinan Regional Programming Contest'"
                                    time='2022.11.28' image_path='images/icpc.svg' :image_style="{ width: '6vw' }" />
                            </div>
                            <div>
                                <VueCompetitionCard
                                    :title="'Gold Medal, The 20th ACM-ICPC Zhejiang Provincial Collegiate Programming Contest'"
                                    time='2023.4.15' image_path='images/icpc.svg' :image_style="{ width: '6vw' }" />
                            </div>
                        </el-main>
                    </el-container>
                </div>
            </el-col>
        </el-row>
    </section>
    <el-row class="last-row">
        <el-col :span="24">
            <div class="last-row-content">
                © 2024
                <img src="images/love.png" class="love-position">
                Gezelligheid1 Pedestrian1
            </div>
        </el-col>
    </el-row>
</template>
  
<!-- 此处 40px 约等于 2.6vw -->
<style scoped>
.title-block {
    margin-left: 7%;
    width: 15vw;
}

.title-content {
    font-size: 2.6vw;
    color: #333;
    margin: 1.3vw 0;
}

.text-row {
    margin-bottom: 0.14vw;
}

.school {
    font-size: 1.3vw;
    font-weight: bold;
    color: #333;
}

.education-content {
    font-size: 1.04vw;
    color: #333;
}

.time {
    font-size: 0.9115vw;
    color: #999;
}

.education-title-layout {
    padding: 0 1.3vw;
    align-content: center;
    height: 3.9vw;
}

.education-title {
    font-size: 1.95vw;
    font-weight: bold;
    color: #333;
}

.graduation-content {
    padding-left: 0vw;
}

.education-icon {
    margin-top: 1vw;
    margin-right: 1.3vw;
}

.education-block {
    text-align: left;
}

.education-container {
    display: flex;
    justify-content: flex-start;
}

.odd-row {
    padding-top: 2.6vw;
    padding-bottom: 3.25vw;
    background-color: rgba(255, 255, 255, 0.95);
}

.even-row {
    padding-top: 2.6vw;
    padding-bottom: 3.25vw;
    background-color: rgba(245, 245, 245, 0.95);
}

.last-row {
    padding-top: 3.25vw;
    padding-bottom: 2.3vw;
}

.last-row-content {
    text-align: center;
    font-size: 0.9115vw;
    color: #999;
}

.head {
    padding-left: 1.3vw;
    font-size: 2.6vw;
    /* font-weight: bold; */
    color: #333;
    font-family: 'montserrat', sans-serif;
}

.avatar-layout {
    margin-left: 25%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.love-position {
    width: 0.85vw;
    transform: translateY(0.065vw);
    /* 调整这个值来下移图片 */
}

.avatar-content {
    width: 13vw;
}

.school-badge-content {
    width: 2.6vw;
}

@media (max-width: 1024px) and (orientation: portrait) {
    .school-badge-content {
        width: 2.6vw;
        transform: translateY(-80%)
    }
}
</style>
  
<script setup>
import { ElContainer, ElMain, ElAside, ElHeader } from 'element-plus'
</script>

<script>
import VueCompetitionCard from './competition_card.vue';
import VueCard from './card.vue';
import NavigationBar from './navbar.vue';
export default {
    name: 'VueMain',
    components: {
        VueCard,
        VueCompetitionCard,
        NavigationBar
    },
    computed: {
        TencentImageStyle() {
            // 使用window.innerWidth来检测屏幕宽度
            // 注意：这种方式只有在客户端渲染时才有效
            const screenWidth = window.innerWidth;
            const screenHeight = window.innerHeight;
            if (screenWidth <= 1024 && screenWidth < screenHeight) { // 假定768px是手机和电脑屏幕大小的分界线
                // 移动端样式
                return {
                    width: '6vw', // 移动端使用50%的视口宽度
                    transform: 'translateY(-1.2vw)'
                };
            } else {
                // 桌面端样式
                return {
                    width: '6vw' // 桌面端使用10%的视口宽度
                };
            }
        },
        DolphinDBImageStyle() {
            // 使用window.innerWidth来检测屏幕宽度
            // 注意：这种方式只有在客户端渲染时才有效
            const screenWidth = window.innerWidth;
            const screenHeight = window.innerHeight;
            if (screenWidth <= 1024 && screenWidth < screenHeight) { // 假定768px是手机和电脑屏幕大小的分界线
                // 移动端样式
                return {
                    width: '6vw', // 移动端使用50%的视口宽度
                    transform: 'translateY(-0.8vw)'
                };
            } else {
                // 桌面端样式
                return {
                    width: '6vw' // 桌面端使用10%的视口宽度
                };
            }
        }
    }
}
</script>